import axios from 'axios';
import CryptoJS from 'crypto-js';
import {Validator} from 'vee-validate';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import VueElementLoading from 'vue-element-loading';
import MasterService from './../../services/masterdata.service';
import ClientService from '../../../clientmanagement/services/clientmanagement.service';

export default {
  name: 'clientebnexemption',
  components: {
    Multiselect,
    VueElementLoading
  },
  props: [],
  data () {
    return {
      isLoading:false,
      userName:'',
      Clientlist:[],
      selectedClients:[],
    }
  },
  computed: {
  },
  async mounted () {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    await this.getCompanyShortName();
    await this.getClientEBNExemption();
  },
  methods: {
    async getCompanyShortName(){
      try {
        this.isLoading = true;
        let InputPayload = {};
        var CompanyShortList = [];
        let result = await ClientService.GetClientListByActiveContracts(InputPayload)
        CompanyShortList = result.data.data.rows;
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.Clientlist.push({
            'clientId': CompanyShortList[i].clientbusinessaccountid,
            'clientName': CompanyShortList[i].clientshortname,
          })
        }
      } catch(err){
        console.log(err);
      }
    },
    async saveClientEBNExemption(){
      try {
        this.isLoading = true;
        let inputPayload=null
        if(this.selectedClients.length>0)
        {
          let clients = this.selectedClients.map(item=>item.clientId);
          inputPayload = {
            username: this.userName,
            clientids : clients
          }
        }
        let result = await MasterService.saveClientEBNExemption(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.$alert(result.data.message, "", "success");
        }else{
          this.$alert(result.data.message, "", "error");
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async getClientEBNExemption(){
      try {
        this.isLoading = true;
        let inputPayload = {
          username: this.userName
        }
        let result = await MasterService.getClientEBNExemption(inputPayload);
        let ebnexemptclient = result.data.data.value;
        this.Clientlist.forEach(item => {
          if(ebnexemptclient.includes(item.clientId)){
            this.selectedClients.push({
              'clientId': item.clientId,
              'clientName': item.clientName,
            })
          }
        });
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/ClientEBNExemptionConfig/saveebnexemption.component.js